import { h } from './dom.js';

export function Spinner({ label = 'Loading…' } = {}) {
  return h('div', { class: 'lib-spinner-wrap', role: 'status' },
    h('div', { class: 'lib-spinner', 'aria-hidden': 'true' }),
    h('span', { class: 'lib-spinner-label' }, label),
  );
}
